import { FC } from 'react';
import * as React from 'react';

import { Loadable } from '@crehana/web';

import { GetLeadBannerSnackBarProp } from './GetLeadBannerSnackBar';

const LazyGetLeadBannerSnackBar: FC<
  React.PropsWithChildren<GetLeadBannerSnackBarProp>
> = props => (
  <Loadable
    module={() =>
      import(
        /* webpackChunkName: "GetLeadBannerSnackBar" */
        './GetLeadBannerSnackBar'
      )
    }
    Loader={<div className="sm:h-72" />}
    {...props}
  />
);

export default LazyGetLeadBannerSnackBar;
